import React, { useContext } from "react";
import { InnerViralTrack } from "./inner";
import { observer } from "mobx-react";
import Loading from "../loading";
import { StoresContext } from "../../pages/_app";

interface Props {
  annotationSetUuid: string;
  assemblyUuid?: string;
}

export const ViralAnnotationTrack = observer((props: Props) => {
  const rootStore = useContext(StoresContext);
  const { annotationStore } = rootStore;
  if (annotationStore.loadingAnnotations) {
    return <Loading text="Loading..." />;
  }
  if (Object.keys(annotationStore.annotations.metadata).length == 0) {
    return null;
  }

  return (
    <InnerViralTrack
      annotationSetUuid={props.annotationSetUuid}
      assemblyUuid={props.assemblyUuid}
    />
  );
});

export default ViralAnnotationTrack;
